<template>
  <v-container>
    <p>
         <v-btn x-large v-if="this.$store.state.raceOpen">
           <router-link to="registration" style="text-decoration: none; color: inherit;">Hier anmelden</router-link>
         </v-btn>
    </p>
        <div class="text-h6" v-if="!this.$store.state.raceOpen">
          Die Anmeldung für 2026 ist leider schon geschlossen
        </div>
        <div class="text-h6" v-if="!this.$store.state.shirtsEnabled && this.$store.state.raceOpen">
          T-Shirts können nicht mehr bestellt werden. Ich könnt aber bei der Startnummerausgabe am 30.5 noch Shirts erwerben
        </div>
        <div class="text-h5">
          Der 15. Lauf gegen Rechts findet am  31. Mai 2026 statt.
        </div>
    <div>
      <p>
      Erneut geht es für uns links um die Alster! Wir freuen uns auf euch. <br/>
      Solidarität statt Nationalismus <br/>
      </p>
    </div>
    <p>
    Daher laufen wir am 31.05.2026 wieder gegen Rechts und…<br/>
    … gegen jeden Antisemitismus und Rassismus.<br/>
    … gegen Sexismus, Antifeminismus, Homo- und Transphobie und Ableismus. <br/>
    … gegen Faschismus und ein Wiedererstarken faschistischer Parteien in Deutschland.<br/>
    … für Solidarität und gegen Nationalismus.<br/>
    … für eine offene, tolerante, diverse und moderne Gesellschaft.<br/>
    … für den sozialen Zusammenhalt und für gesellschaftliche Teilhabe<br/> 
  </p>
    <p>
    #allezusammengegendenfaschismus #liebdochwenduwillst
#leavenoonebehind #refugeeswelcome #noafd#allcolorsarebeautiful
    </p>

    <p>
      Lauf gegen Rechts 2026: am 31.Mai Alsterwiese Schwanenwik<br/>
      Um die Alster & auch dezentral sowie International<br/>
      Der gesamte Erlös wird antirassistischen Initiativen und Gruppen, die Geflüchtete unterstützen sowie dem Hamburger Bündnis gegen Rechts, gespendet<br/>
    </p>
    <p>
      <a href="https://www.fcstpauli-marathon.de">www.fcstpauli-marathon.de</a><br/>
      <a href="https://www.hbgr.org">www.hbgr.org</a>
    </p>
    <p>
      Anmeldeschluss: 10. Mai 2026<br/>
      Bestellfrist für T-Shirts: 19. April 2026
    </p>
    <p>
         <v-btn x-large v-if="this.$store.state.raceOpen">
           <router-link to="registration" style="text-decoration: none; color: inherit;">Hier anmelden</router-link>
         </v-btn>
    </p>


    <p>
      <b>Für den Lauf an der Alster sind keine Nachmeldungen möglich</b><br/>
      Nachmeldungen gibt es ausschließlich für dezentrale Läufe bei der Startnummernausgabe. <br/>
      Nur die Läufer*innen, die sich online bis zum 10.05. angemeldet haben können mit um die Alster laufen – bitte unterstützt uns, indem ihr nicht mit nachgemeldeten Startnummern an die Alster kommt.<br/>
      Gedruckte Startnummern erhalten alle, die sich bis zum 10.5. online für den Alsterlauf angemeldet haben. Selbst ausdrucken ist ebenfalls möglich.<br/>
      Startnummernausgabe am Samstag, 30.5., 11–17 Uhr vor den Fanräumen am Millerntor-Stadion (Heiligengeistfeld, Gegengerade)<br/>
      <ul>
      <li>Dort gibt es auch T-Shirts, solange der Vorrat reicht.</li>
      <li>Bereits online bestellte T-Shirts wurden bereits per Post verschickt.</li>
      <li>Wir empfehlen euch, die Startnummer schon am Samstag abzuholen, um Wartezeiten am Sonntag zu vermeiden.</li>
      </ul>
      Startnummernausgabe am Sonntag, 31.5., ab 8 Uhr Alsterwiese Schwanenwik im Start-/Zielbereich<br/>
      <b>Wichtig:</b> bitte kommt nur von Süden auf die Alsterwiese und nutzt nicht den schmalen Weg von Norden durch den Startbereich!<br/>
    </p>
    <p>
      Ihr könnt den Lauf auch außerhalb Hamburgs organisieren oder euch bestehenden Gruppen anschließen<br/>
      Bisher bekannte dezentrale Läufe am 31.5. sind:<br/>
      <ul>
        <li>Jever, Dorfplatz Cleverns, 10 Uhr, #buntläuftbesser</li>
        <li>Hohenhameln Dorf Equord, 13 Uhr, insta @equord_ist_bunt</li>
        <li>Nürnberg VISAVAJARA, Johannesgasse 6, 10 Uhr bitte kurze Info über Teilnahmen an insta @visavajara_nuernberg oder mail: nuernberg@visavajara.com</li>
        <li>Salzwedel, Park des Friedens, 10 Uhr Nachmeldungen vor Ort möglich</li>
      </ul>
      Wenn ihr weitere dezentrale Läufe organisiert, informiert uns gern, damit sich andere anschließen können. Wir freuen uns über alle Laufgruppen, die auch abseits der Alster ein starkes Zeichen gegen Rechts setzen – daher lauft in euren Städten, Dörfern und Stadtteilen und schickt uns Bildmaterial über unsere Social Media Kanäle. Postet eure Läufe gern unter #lgr2026 oder #lgr26 oder markiert: Facebook: St. Pauli Lauf gegen Rechts Insta: @lauf_gegen_rechts
    </p>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "RaceStatus",
  data: () => ({
    raceInfo: {}
  }),
  mounted: function () {
    this.getRace()
  },
  methods: {
    getRace() {
      const url = `${this.$base_url}/race/`

      axios.get(url)
          .then((response) => {
            this.raceInfo = response.data
            this.$store.commit('setRaceStatus', response.data.isOpen)
            this.$store.commit('setShirtsEnabled', response.data.shirtsEnabled)
          })
    }
  }
}

</script>

<style scoped>

</style>
